import React from "react";

const CartAdmin = () => {
  return <div>CartAdmin</div>;
};

export default CartAdmin;
